import { Ref } from "react";
import { WebApiRequest, HTTP_GET, HTTP_PUT } from "tools/webservice";
import { WebApiBlobRequest } from "tools/webservice/WebApiBlobRequest";

export const getBadgePhotoExists = (
  inspectorNumber: number,
  successCallback: (exists: boolean) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>,
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/inspector/${inspectorNumber}/badge-photo-exists`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const getBadgePhoto = (
  inspectorNumber: number,
  successCallback: (blob: Blob) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>,
) =>
  WebApiBlobRequest({
    method: HTTP_GET,
    endpoint: `/inspector/${inspectorNumber}/badge-photo`,
    successCallback,
    errorCallback,
    mountedRef,
    disableDefaultErrorResponseHandler: true,
  });

export const updateBadgePhoto = (
  inspectorNumber: number,
  file: File,
  successCallback: () => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>,
) =>
  WebApiRequest({
    method: HTTP_PUT,
    endpoint: `/inspector/${inspectorNumber}/badge-photo`,
    file,
    successCallback,
    errorCallback,
    mountedRef,
  });
